export default __webpack_public_path__ + "static/abmg-group-photo-cc5312006e5aca2223f244746f69242b.jpg";